import AbstractFlowModel from 'garaje/models/abstract/abstract-flow';
import OnboardingChangesTracker from 'garaje/utils/decorators/onboarding-changes-tracker';
import PropagableChangesTracker from 'garaje/utils/decorators/propagable-changes-tracker';

@PropagableChangesTracker
@OnboardingChangesTracker
class PropagableModel extends AbstractFlowModel {}

export default PropagableModel;
